(function () {
    myonce('geo', function () {
        const $target = document.querySelector('[data-geo]');
        let gAPi = retrieveConfig(document).config.gApi;
        if ($target) {
            const script = document.createElement('script');
            script.src = `${mapsURI}/js?key=${gAPi}&callback=initMap`;
            script.defer = true;
            script.async = true;
            window.initMap = function () {
                let _pcache = sessionStorage.getItem('_pcache') || {};
                resolvePosition(_pcache).then(position => {
                    geocodeCities(position);
                });
            };
            document.head.appendChild(script);
        }
        function retrieveConfig($wrapper) {
            let data = {
                url: '',
                config: {},
            };
            const $form = $wrapper && $wrapper.querySelector('.ep-config');
            if ($form) {
                try {
                    const url = $form.querySelector('[name="url"]').value;
                    const config = $form.querySelector('[name="config"]').value;
                    data = {
                        url: url.replace(/\/$/, ''),
                        config: JSON.parse(config),
                    };
                }
                catch (e) {
                    console.log('Error during retrieval of configuration for current service. %s', e);
                }
            }
            return data;
        }
        function extractCity(gapiResponse) {
            let locality = gapiResponse.filter(item => item.types.includes('locality'))[0] ||
                gapiResponse.filter(item => item.types.includes('postal_code'))[0];
            return locality ? locality.formatted_address : '-';
        }
        function geocodeCities(position) {
            const $targets = document.querySelectorAll('[data-geocode-city]');
            if ($targets.length) {
                if (position.city) {
                    $targets.forEach($target => {
                        $target.removeAttribute('data-spinner');
                        $target.textContent = position.city;
                    });
                }
                else {
                    const { coords } = position;
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({
                        location: {
                            lat: coords.latitude,
                            lng: coords.longitude,
                        },
                    }, function (results, status) {
                        if (status === 'OK') {
                            const city = extractCity(results);
                            $targets.forEach($target => {
                                $target.removeAttribute('data-spinner');
                                $target.textContent = city;
                            });
                            sessionStorage.setItem('_pcache', JSON.stringify({
                                coords: {
                                    latitude: position.coords.latitude,
                                    longitude: position.coords.longitude,
                                },
                                city,
                                timestamp: position.timestamp,
                            }));
                        }
                        else {
                            $targets.forEach($target => {
                                $target.removeAttribute('data-spinner');
                                $target.textContent = '-';
                            });
                        }
                    });
                }
            }
        }
        function getZipCode(coordinates) {
            return new Promise((resolve, reject) => {
                const getCoords = new Promise((resolve, reject) => {
                    if (coordinates) {
                        resolve({ coords: coordinates });
                    }
                    else {
                        resolvePosition(sessionStorage.getItem('_pcache') || {})
                            .then(coords => {
                            resolve(coords);
                        });
                    }
                });
                getCoords.then(({ coords }) => {
                    const geocoder = new google.maps.Geocoder();
                    geocoder.geocode({
                        location: {
                            lat: coords.latitude,
                            lng: coords.longitude,
                        },
                    }, function (results, status) {
                        if (status === 'OK') {
                            let i, len, found;
                            i = 0;
                            len = results.length;
                            while (i < len && !found) {
                                let j = 0;
                                let result = results[i];
                                let lenJ = result['address_components'].length;
                                while (j < lenJ && !found) {
                                    const item = result['address_components'][j];
                                    found = item.types.includes('postal_code') ? item['short_name'] : found;
                                    !found && j++;
                                }
                                !found && i++;
                            }
                            found ? resolve(found) : reject();
                        }
                        else {
                            reject();
                        }
                    });
                });
            });
        }
        function resolvePosition(_pcache) {
            return new Promise((resolve, reject) => {
                if (_pcache.coords && _pcache.timestamp && !shouldUpdate(_pcache)) {
                    resolve(_pcache);
                }
                else {
                    navigator.geolocation.getCurrentPosition(resolve, reject);
                    window.setTimeout(() => {
                        reject('Aborted due to timeout');
                    }, 15000);
                }
            }).then(position => {
                if (shouldUpdate(_pcache)) {
                    sessionStorage.setItem('_pcache', JSON.stringify({
                        coords: {
                            latitude: position.coords.latitude,
                            longitude: position.coords.longitude,
                        },
                        timestamp: position.timestamp,
                    }));
                    _pcache = position;
                }
                return position;
            });
        }
        function shouldUpdate(_pcache) {
            const THRESHOLD = 3600000; 
            return !_pcache.timestamp || Date.now() - _pcache.timestamp > THRESHOLD;
        }
        publish(() => {
            return resolvePosition(sessionStorage.getItem('_pcache') || {});
        }, 'getCoords');
        publish(getZipCode, 'getZipCode');
    });
})();
